import { render, staticRenderFns } from "./PostPrologue.vue?vue&type=template&id=7a6662c6&scoped=true"
import script from "./PostPrologue.vue?vue&type=script&lang=js"
export * from "./PostPrologue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6662c6",
  null
  
)

export default component.exports